import type { ClientOrder } from "../services/clientApi.service";

/**
 * Mapping libellé + couleur pour les statuts de commande affichés côté portail client.
 * Adapté à la sémantique livraison vs retrait sur place (`READY` = "Prêt à retirer").
 */

export type ClientOrderStatus = ClientOrder["status"];

export interface ClientOrderStatusInfo {
  label: string;
  color: "default" | "primary" | "success" | "warning" | "error" | "info";
}

export function getClientOrderStatusInfo(
  status: ClientOrderStatus,
  serviceType: ClientOrder["serviceType"],
): ClientOrderStatusInfo {
  switch (status) {
    case "PENDING":
      return { label: "En attente de confirmation", color: "warning" };
    case "CONFIRMED":
      return { label: "Confirmée", color: "info" };
    case "IN_PREPARATION":
      return { label: "En préparation", color: "info" };
    case "READY":
      return {
        label: serviceType === "CATERING" ? "Prête à retirer" : "Prête",
        color: "primary",
      };
    case "IN_DELIVERY":
      return { label: "En cours de livraison", color: "primary" };
    case "DELIVERED":
      return {
        label: serviceType === "CATERING" ? "Récupérée" : "Livrée",
        color: "success",
      };
    case "CANCELLED":
      return { label: "Annulée", color: "error" };
    default:
      return { label: status, color: "default" };
  }
}

/** Renvoie `true` si une commande peut encore être annulée par le client (avant confirmation). */
export function canCancelOrder(status: ClientOrderStatus): boolean {
  return status === "PENDING";
}
